import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk10() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`X.`}
            <br />
            {`Doručovanie`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Oznámenie týkajúce sa vzťahov poskytovateľa a používateľa, najmä týkajúce sa odstúpenia od zmluvy, môže byť doručené poštou formou doporučeného listu, e-mailom či prostredníctvom používateľského účtu. Oznámenia sa doručujú na príslušnú kontaktnú adresu druhej strany a považujú sa za doručené a účinné okamihom ich dodania prostredníctvom pošty, s výnimkou oznámenia o odstúpení od zmluvy realizovaného používateľom, keď je odstúpenie účinné vtedy, ak je oznámenie používateľovi v lehote na odstúpenie odoslané.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={2} className={sList}>
            <li>{`Za doručené sa považuje aj oznámenie, prevzatie ktorého bolo adresátom odmietnuté, ktoré nebolo vyzdvihnuté v úložnej lehote, alebo ktoré sa vrátilo ako nedoručiteľné.`}</li>
            <li>{`Zmluvné strany môžu bežnú korešpondenciu navzájom doručovať prostredníctvom elektronickej pošty, a to na adresu elektronickej pošty uvedenú v používateľskom účte používateľa či uvedenú používateľom v objednávke, resp. na adresu uvedenú na webovej stránke poskytovateľa.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk10;
